import MuiBadge from '@mui/material/Badge'
import { styled } from '@mui/material/styles'

export const StandaloneBadge = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text['on-color'],
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 700,
  fontFamily: 'Nunito, sans-serif',
  '&.status-new': {
    backgroundColor: theme.palette.action['destructive-primary-bg-default'],
  },
  '&.status-count': {
    backgroundColor: theme.palette.action['primary-bg-default'],
  },
  '&.size-m': {
    minWidth: '20px',
    height: '20px',
    borderRadius: '24px',
    padding: theme.spacing(0, 0.75),
  },
  '&.size-s': {
    padding: theme.spacing(0, 0.5),
    minWidth: '16px',
    height: '16px',
    borderRadius: '24px',
  },
  '&.size-xs': {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
  },
}))

export const StyledMuiBadge = styled(MuiBadge)(({ theme }) => ({
  '.MuiBadge-standard': {
    color: theme.palette.text['on-color'],
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 700,
    fontFamily: 'Nunito, sans-serif',
    '&.size-m': {
      width: '20px',
      height: '20px',
    },
    '&.size-s': {
      width: '16px',
      height: '16px',
    },
  },
  '.MuiBadge-standard, .MuiBadge-dot': {
    '&.status-new': {
      backgroundColor: theme.palette.action['destructive-primary-bg-default'],
    },
    '&.status-count': {
      backgroundColor: theme.palette.action['primary-bg-default'],
    },
  },
}))
